module.exports = __webpack_public_path__ + "img/70.ac2a6244.png";